import * as Yup from 'yup';

export default Yup.object({
  height: Yup.number()
    .required('Required')
    .min(15, 'Height must be at least 15 inches')
    .max(105, 'Height must be at most 105 inches')
});
